interface ILoadingDotsProps {
  isLoading: boolean;
  text: string | React.ReactNode;
  darkMode?: boolean;
}

export const LoadingDots = ({ isLoading, text, darkMode }: ILoadingDotsProps) => {
  return (
    <>
      {isLoading ? (
        <div className="loading-dots flex space-x-1 justify-center h-[20px] items-center">
          <span className="sr-only">Loading...</span>
          <div className={`h-3 w-3 rounded-full animate-bounce ${darkMode ? 'bg-[#4B303C]' : 'bg-white'} [animation-delay:-0.6s]`}></div>
          <div className={`h-3 w-3 rounded-full animate-bounce ${darkMode ? 'bg-[#4B303C]' : 'bg-white'} [animation-delay:-0.3s]`}></div>
          <div className={`h-3 w-3 rounded-full animate-bounce ${darkMode ? 'bg-[#4B303C]' : 'bg-white'}`}></div>
        </div>
      ) : (
        text
      )}
    </>
  );
};
